<div class="alert flex flex-row items-center bg-green-200 p-5 rounded border-b-2 border-green-300 mt-4 mb-4">
   <a href="javascript:void(0)" (click)="clickApriPdf()"><span>Clicca qui</span></a>&nbsp; per visionare la guida ZENT per realizzare foto di qualità dei prodotti.
</div>

<app-alert [mode]="'info'" [htmlMessage]="'<p class=m-0><b>Le immagini devono rispettare i seguenti requisiti:</b></p> <br>' +
 '<ol>' +
   '<li>- Dimensione minima: 1200x1200 pixel</li>' +
   '<li>- Dimensione massima: 3200x3200 pixel</li>' +
   '<li>- Dimensione file: massimo 1 MB</li>' +
 '</ol>'
"></app-alert>

<div *ngIf="!isVariante && pVariant.length > 0">
   <mat-form-field appearance="fill" class="w-full" >
      <mat-label>Variante</mat-label>
      <mat-select placeholder="Stagione" (selectionChange)="selectPVariant($event.value)">
         <mat-option *ngFor="let variante of pVariant"
                     value="{{variante.data.id}}">
            {{variante.data.codice}} ({{variante.data.colore_str}})
         </mat-option>
      </mat-select>
   </mat-form-field>
</div>

<div *ngIf="!isVariante && pVariant.length == 0">
   <div class="alert flex flex-row items-center bg-yellow-200 p-5 rounded border-b-2 border-yellow-300 mt-5" *ngIf="pVariant.length == 0">
      <span class="text-yellow-500">
         <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-alert-circle" width="48" height="48" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <circle cx="12" cy="12" r="9"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
         </svg>
      </span>
      <div class="alert-content ml-4">
         <div class="alert-title font-semibold text-lg text-yellow-800">
            Non ci sono varianti registrate.
         </div>
         <div class="alert-description text-sm text-yellow-600">
            Prima di inserire le immagini, crea almeno una <a class="cursor-pointer"
                                                              (click)="clickChangeTab()">variante</a>.
         </div>
      </div>
   </div>
</div>

<dx-data-grid #gridImage class="mt-3 mb-14" id="gridContainerImage" [rowAlternationEnabled]="true" [hidden]="!pVariantId">

   <dxo-row-dragging
      [allowReordering]="true"
      [onReorder]="onReorder"
      dropFeedbackMode="push">
   </dxo-row-dragging>

   <dxo-editing
      mode="cell"
      [allowUpdating]="true"
   ></dxo-editing>

   <dxi-column [allowSorting]="false" [allowEditing]="false"
               alignment="center"
               dataField="index" width="100" [allowHeaderFiltering]="false" [allowFiltering]="false"
               caption="Indice"></dxi-column>

   <dxi-column cssClass="dx-column-image"
               alignment="left"
               [allowHeaderFiltering]="false" [allowFiltering]="false" [allowEditing]="false"
               caption="Immagine" cellTemplate="imageTemplate"></dxi-column>
   <div *dxTemplate="let item of 'imageTemplate'">
      <div>
         <a [href]="item.data.image" target="_blank"><img [src]="item.data.image" alt="image" ></a>
      </div>
   </div>

   <dxi-column dataField="image"
               [allowHeaderFiltering]="false" [allowFiltering]="false" [allowEditing]="false"
               caption="Immagine" cellTemplate="imageLinkTemplate"></dxi-column>
   <div *dxTemplate="let cellInfo of 'imageLinkTemplate'">
      <a [href]="cellInfo.data.image" target="_blank">{{cellInfo.data.image}}</a>
   </div>

   <dxi-column [allowSorting]="false" [allowFiltering]="false"
               dataField="pub_marketplaces" dataType="boolean"
               width="120" alignment="center"
               [allowHeaderFiltering]="false" caption="Marketplaces"></dxi-column>

   <dxi-column [allowSorting]="false" [allowFiltering]="false"
               dataField="is_published" dataType="boolean"
               width="120" alignment="center"
               [allowHeaderFiltering]="false" caption="Pubblicata"></dxi-column>

   <dxi-column caption="Elimina" width="100" alignment="center"
               cellTemplate="eliminaTemplate"></dxi-column>
   <div *dxTemplate="let cellInfo of 'eliminaTemplate'">
      <button class="btn-tbl-trash"
              (click)="clickEliminaImmagine(cellInfo.data.id)" tabindex="-1">
         <i class="fa-light fa-trash-can"></i>
      </button>
   </div>
</dx-data-grid>

<ng-template #popupContent>
   <app-modal-upload-file #appModalUploadComponent></app-modal-upload-file>
</ng-template>

<app-popup-generic #dialogImages
                   [autoclose]="false"
                   [(visible)]="popupImmaginiVisible"
                   [content]="popupContent"
                   [buttons]="[{text:'Carica Immagini', key:'ok'}]"
                   (onClick)="clickUploadImage()"
                   title="Carica Immagini">
</app-popup-generic>
